function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#757575;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -61)"
}, React.createElement("path", {
  className: "a",
  d: "M43.846,128.692a13.846,13.846,0,1,1,13.846-13.846A13.862,13.862,0,0,1,43.846,128.692Z",
  transform: "translate(-23.077 -30.769)"
}), React.createElement("path", {
  className: "a",
  d: "M253.846,88.692a13.846,13.846,0,1,1,13.846-13.846A13.862,13.862,0,0,1,253.846,88.692Z",
  transform: "translate(-184.615)"
}), React.createElement("path", {
  className: "a",
  d: "M114.692,161H100.846a3.462,3.462,0,1,0,0,6.923h5.489L70.846,203.412l-9.091-9.091a3.462,3.462,0,0,0-4.9,0L30.182,221H3.462a3.462,3.462,0,0,0,0,6.923H31.615a3.46,3.46,0,0,0,2.448-1.014l25.245-25.245,9.091,9.091a3.462,3.462,0,0,0,4.9,0l37.937-37.937v5.489a3.462,3.462,0,0,0,6.923,0V164.462A3.462,3.462,0,0,0,114.692,161Z",
  transform: "translate(0 -76.923)"
}), React.createElement("path", {
  className: "a",
  d: "M242.244,195.978a20.724,20.724,0,0,1-22.95,0A20.749,20.749,0,0,0,210,213.291v6.545l3.5-3.5a10.385,10.385,0,0,1,14.686,0l4.2,4.2L249.2,203.711A20.868,20.868,0,0,0,242.244,195.978Z",
  transform: "translate(-161.538 -103.829)"
}), React.createElement("path", {
  className: "a",
  d: "M9.294,235.978A20.749,20.749,0,0,0,0,253.291v18.462H27.314l14.225-14.224v-4.237a20.749,20.749,0,0,0-9.294-17.313,20.725,20.725,0,0,1-22.95,0Z",
  transform: "translate(0 -134.598)"
}));

var SvgGrowthImg = function SvgGrowthImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 118.154,
    height: 90,
    viewBox: "0 0 118.154 90",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGrowthImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/growth_img.8de89592.svg";
export { ForwardRef as ReactComponent };